import { GroupBase, OptionProps, components } from "react-select5";

export function OptionComponent<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: OptionProps<Option, IsMulti, Group>) {
  if (!props.children) return;
  return <components.Option {...props} />;
}
